import React, { useState, useEffect } from 'react';
import { Collapse } from 'reactstrap';
import { FaAngleDown } from 'react-icons/fa6';
import { FaMinus } from 'react-icons/fa6';

interface FilterSectionProps {
  /** Array of items (any) */
  itemList: any[];
  /** Function to render each item */
  renderFunction: any;
  /** Function to filter the item list */
  filterFunction?: any;
  /** Function to sort the item list */
  sortFunction?: any;
  /** Title for the section */
  title: string;
  /** Optional icon rendered before the title */
  icon?: React.ReactNode;
  /** Display amount of items next to the title */
  displayItemCount?: boolean;
  /** Initial value for collapsed state */
  isOpen?: boolean;
}

export const FilterSection = ({
  itemList,
  renderFunction,
  filterFunction,
  sortFunction,
  title,
  icon,
  displayItemCount = true,
  isOpen = true,
}: FilterSectionProps) => {
  const [open, setOpen] = useState(isOpen);
  const [itemCount, setItemCount] = useState(0);
  const [filteredItems, setFilteredItems] = useState(itemList);

  const handleOpenToggle = () => {
    if (itemCount > 0) {
      setOpen(!open);
    }
  };

  useEffect(() => {
    let items = itemList;
    if (filterFunction) {
      items = itemList.filter(filterFunction);
    }
    if (sortFunction) {
      items = items.sort(sortFunction);
    }
    setFilteredItems(items);
    const newCount = items.length;
    if (newCount <= 0) {
      setOpen(false);
    } else if (itemCount <= 0) {
      setOpen(isOpen);
    }
    setItemCount(newCount);
  }, [itemList]);

  return (
    <div className={`filter-section${open ? ' open' : ''}`}>
      <button onClick={handleOpenToggle}>
        <span className="filter-section-title">
          {icon && <span className="filter-section-title-icon">{icon}</span>}
          {title}
          {displayItemCount && <span className="filter-section-item-count">{itemCount}</span>}
        </span>
        <span className="filter-section-icon">
          {itemCount > 0 ? <FaAngleDown /> : <FaMinus className="minus" />}
        </span>
      </button>
      <Collapse isOpen={open}>
        {filteredItems.map((item: any, index: number) => (
          <React.Fragment key={index}>{renderFunction(item, index)}</React.Fragment>
        ))}
      </Collapse>
    </div>
  );
};
